import React, { useState, useEffect } from 'react';

import { Copy } from 'react-feather';

import CopyIcon from '../../assets/copy.svg';
import PaperPlaneIcon from '../../assets/paper-plane.svg';
import BitcoinIcon from '../../assets/bitcoin.svg';
import FacebookIcon from '../../assets/facebook-icon.png';
import TwitterIcon from '../../assets/twitter-icon.png';
import WhatappIcon from '../../assets/whatsapp-icon.png';

import {
  Container,
  OrangeBox,
  Item,
  ItemText,
  ItemDivider,
  WhiteBox,
  AlignDescription,
  Description,
  CopyBox,
  CopyBoxText,
  CopyButton,
  SubTitle,
  SocialMedias,
  SocialMediaButton,
  SocialMedia,
  ControlPanel,
} from '../../styles/pages/recommendation/styles';
import { Button, List, Title } from '../../components/UI';

import withAuth from '../../components/HigherOrder/withAuth';
import IndicationExt from '../../components/Modal/indicationExt';
import { ReferralInfo } from '../../models/user';
import { useUser } from '../../hooks/user';
import { set } from 'lodash';
import Skeleton from '../../components/Skeleton';
import { LockField } from '../../components/UI/Button/styles';
import { t } from 'i18next';

const Recommendation: React.FC = () => {
  const [openShareModal, setOpenShareModal] = useState<boolean>(null);
  const [referralInfo, setReferralInfo] = useState<ReferralInfo>();
  const [loading, setLoading] = useState<boolean>(true);

  const { getReferralInfo } = useUser();

  const handleOpenShareModal = () => {
    if (openShareModal === null || openShareModal === false) {
      setOpenShareModal(true);
    } else {
      setOpenShareModal(false);
    }
  };

  const handleCloseShareModal = () => {
    setOpenShareModal(false);
  };

  useEffect(() => {
    async function getInitialData() {
      try {
        const response = await getReferralInfo();
        setReferralInfo(response);
        setLoading(false);
      } catch (error) {
        setLoading(true);
        console.error(error);
      }
    }

    getInitialData();
  }, []);

  return (
    <>
      <IndicationExt open={openShareModal} onClose={handleCloseShareModal} />
      <Container>
        <OrangeBox>
          <Item>
            <CopyIcon height={64} width={64} />
            <ItemText>{t('pages.recommendation.copy-link')}</ItemText>
          </Item>
          <ItemDivider />
          <Item>
            <PaperPlaneIcon height={64} width={64} />
            <ItemText>
              {t('pages.recommendation.send-to-your-friends-or-share-on-social-media')}
            </ItemText>
          </Item>
          <ItemDivider />
          <Item>
            <BitcoinIcon height={64} width={64} />
            <ItemText>{t('pages.recommendation.earn-points-for-the-airdrop-when-your-friend-earns-satoshis')}</ItemText>
          </Item>
        </OrangeBox>
        <ControlPanel>
          <h1>{t('pages.recommendation.control-panel')}</h1>
          <div className="container" style={{ gap: 20 }}>
            {
              (parseFloat(referralInfo?.balance_available_earned) > 0 ?? parseFloat(referralInfo?.balance_pending_earned_formatted) > 0) && (
                <div className="bigCard">
                  <h2>{t('pages.recommendation.your-earnings')}</h2>
                  {loading ? (
                    <Skeleton className="loadingBigCard" />
                  ) : (
                    <h1>
                      {referralInfo?.balance_available_earned}
                    </h1>
                  )}
                  <div className="cashInProcess">
                    <span>{t('pages.recommendation.balance-being-processed')}</span>
                    {loading ? (
                      <Skeleton className="loadingCashInProcess" />
                    ) : (
                      <span>{referralInfo?.balance_pending_earned_formatted}</span>
                    )}
                  </div>
                </div>
              )
            }
            <div className="bigCard" style={{ justifyContent: 'start' }}>
              <h2>{t('pages.recommendation.your-airdrop-point-earnings')}</h2>
              {loading ? (
                <Skeleton className="loadingBigCard" />
              ) : (
                <h1>
                  {referralInfo?.airdrop_point_earned}
                </h1>
              )}
            </div>
            <div className="card">
              <h2>{t('pages.recommendation.friends-who-are-earning')}</h2>
              {loading ? (
                <Skeleton className="loadingBigCard" />
              ) : (
                <h1>{referralInfo?.referred_users_earning_count}</h1>
              )}
            </div>
            <div className="card">
              <h2>{t('pages.recommendation.friends')}</h2>
              {loading ? (
                <Skeleton className="loadingBigCard" />
              ) : (
                <h1>{referralInfo?.referred_users_count}</h1>
              )}
            </div>
          </div>
        </ControlPanel>
        <WhiteBox>
          <Title>{t('pages.recommendation.invite-your-friends')}</Title>
          <AlignDescription>
            <Description>
              {t('pages.recommendation.copy-and-send-the-referral-link-to-friends')}.
            </Description>
            <Description>
              {t('pages.recommendation.share-with-your-friends-and-earn-bitcoin-together')}.
            </Description>
          </AlignDescription>
          <Button className="shareButton" onClick={handleOpenShareModal}>
            {t('pages.recommendation.share')}
          </Button>
          <Description>
            {t('pages.recommendation.first-make-sure-to-read-the-general-terms-and-conditions-of-our-referral-program')} ↓
          </Description>
        </WhiteBox>
      </Container>
    </>
  );
};

export default withAuth(Recommendation);
